export default __webpack_public_path__ + "static/media/3.22.c57afc63.mp3";